/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Auction_AdvertisementInputs */

const cs_enum_auction_advertisement = /** @type {(inputs: Enum_Auction_AdvertisementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dražební vyhláška`)
};

const en_enum_auction_advertisement = /** @type {(inputs: Enum_Auction_AdvertisementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction advert`)
};

/**
* | output |
* | --- |
* | "Auction advert" |
*
* @param {Enum_Auction_AdvertisementInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_auction_advertisement = /** @type {((inputs?: Enum_Auction_AdvertisementInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Auction_AdvertisementInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_auction_advertisement(inputs)
	return cs_enum_auction_advertisement(inputs)
});